import { InvoiceStatus, type InvoiceStatusTag } from './types'

export const getInvoiceStatusTag = (
  status: InvoiceStatus,
  t: (key: string) => string
): InvoiceStatusTag => {
  switch (status) {
    case InvoiceStatus.PAID:
      return { state: 'success', label: t('billing.paid') }
    case InvoiceStatus.UNPAID:
      return { state: 'warning', label: t('billing.unpaid') }
    case InvoiceStatus.COMMERCIAL_APPROVED:
      return { state: 'feature', label: t('billing.commercialApproved') }
    default:
      return { state: 'neutral', label: status }
  }
}
